import { faExclamationTriangle } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getSessionData, setSecondarySessionData } from "redux/actions";

const fetchSessionData = async (sessionId, dispatch, setSessionData) => {
    const sessionData = await dispatch(getSessionData(sessionId));

    setSessionData(sessionData);
};

const CLICK_TO_COPY = "Click to copy";
const COPIED = "Copied!";

const RailCompareDraggableListItem = ({ sessionId, comparableSessions, selectedSession, selectedItemRef, handleClick, style }) => {
    const selectedSessionInRange = comparableSessions.includes(sessionId);
    const isSelectedSession = sessionId === selectedSession;
    const [sessionData, setSessionData] = useState(null);
    const [copiedText, setCopiedText] = useState(CLICK_TO_COPY);
    const dispatch = useDispatch();

    useEffect(() => {
        fetchSessionData(sessionId, dispatch, setSessionData);
    }, [dispatch, sessionId]);

    useEffect(() => {
        if (copiedText !== COPIED) return;

        const timeOut = setTimeout(() => {
            setCopiedText(CLICK_TO_COPY);
        }, 1000);

        return () => {
            clearTimeout(timeOut);
        };
    }, [copiedText]);

    const handleClipBoardClick = useCallback(
        (e) => {
            e.stopPropagation();
            setCopiedText(COPIED);
            try {
                navigator.clipboard.writeText(sessionId);
            } catch {
                setCopiedText("Failed to copy to clipboard.");
            }
        },
        [sessionId],
    );

    const _style = {
        ...style,
        border: `2px solid ${isSelectedSession ? "#b09aee" : "transparent"}`,
        backgroundColor: "#4d5879",
        borderRadius: "4px",
        padding: "2px",
    };

    if (!sessionData) {
        return (
            <div
                ref={isSelectedSession ? selectedItemRef : null}
                className={`inspection-default-button compare w-full ${isSelectedSession ? "active" : ""} animate-pulse`}
                style={_style}
            />
        );
    }

    return (
        <div
            ref={isSelectedSession ? selectedItemRef : null}
            className={`inspection-default-button compare center w-full h-full flex flex-col ${isSelectedSession ? "active" : ""} justify-center items-start overflow-hidden InspectionCompareSessionItem`}
            onClick={() => {
                handleClick(sessionId);
                dispatch(setSecondarySessionData(sessionData));
            }}
            style={{ ..._style, justifyContent: "center" }}>
            <div className="flex w-full justify-between">
                <strong style={{ fontSize: "16px" }}>{new Date(parseFloat(sessionData.first_seen) * 1000).toDateString()}</strong>
                <Tooltip title={copiedText}>
                    <span
                        className="flex overflow-hidden text-ellipsis text-nowrap whitespace-nowrap items-center SessionId"
                        onClick={handleClipBoardClick}
                        style={{ gap: "4px", color: "#9797b7" }}>
                        {selectedSessionInRange ? (
                            `# ${sessionId}`
                        ) : (
                            <>
                                <Tooltip title="Selected session no longer in current bounds">
                                    <FontAwesomeIcon icon={faExclamationTriangle} />
                                </Tooltip>
                                {sessionId}
                            </>
                        )}
                    </span>
                </Tooltip>
            </div>
            <span style={{ color: "#9797b7" }}>{sessionData.route_name}</span>
        </div>
    );
};

export default RailCompareDraggableListItem;
